export const vimeoUrlPattern = /vimeo/;

export function isVimeoVideoUrl(url: string) {
  return vimeoUrlPattern.exec(url);
}
